import { render } from "./ViolationsComponent.vue?vue&type=template&id=1ab43583"
import script from "./ViolationsComponent.vue?vue&type=script&lang=js"
export * from "./ViolationsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__